import { configureStore } from "@reduxjs/toolkit";
import UserSlice from "./Slices/UserSlice/UserSlice";
import WorksSlice from "./Slices/WorksSlice/WorksSlice";
import MainSlice from "./Slices/MainSlice/MainSlice";
import ProjectSlice from "./Slices/ProjectSlice/ProjectSlice";
import BlankSlice from "./Slices/BlankSlice/BlankSlice";
import { injectStore } from "Api";

const store = configureStore({
  reducer: {
    user: UserSlice,
    works: WorksSlice,
    mainState: MainSlice,
    project: ProjectSlice,
    blank: BlankSlice,
  },
});

injectStore(store);

export { store };
